"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fonts = {
  montserrat: 'Montserrat, Helvetica, Arial, sans-serif',
  roboto: 'Roboto, Arial, sans-serif'
};
var _default = fonts;
exports["default"] = _default;